
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-sales",
      function () {
        return require("private-next-pages/contact-sales.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-sales"])
      });
    }
  